/* eslint-disable no-console */
<template>
  <div>
    <b-form @submit.prevent="siteSearchReach">
      <b-form-row class="mb-2">
        <b-col
          sm="6"
          md="6"
          lg="2"
        >
          <label for="reach-date-from">Konsumtionsdatum från</label><br>
          <p class="d-inline-block fontsizeconsumptionp">
            {{ dateFrom }}
          </p>
        </b-col>

        <b-col
          sm="6"
          md="6"
          lg="2"
        >
          <label for="reach-date-to">Konsumtionsdatum till</label><br>
          <p class="d-inline-block fontsizeconsumptionp">
            {{ dateTo }}
          </p>
        </b-col>

        <b-col
          sm="6"
          md="6"
          lg="2"
          style="min-width: 13.5rem;"
        >
          <label for="target-group">Reachvillkor</label>
          <b-form-select
            id="target-group"
            v-model="minViewingTimeSelection"
            :options="minViewingTimeOptions"
            size="sm"
          />
        </b-col>

        <b-col
          sm="6"
          md="6"
          lg="2"
          class="align-self-center"
        >
          <b-button
            id="refresh-reach"
            type="submit"
            class="float-right"
            variant="primary"
            size="sm"
          >
            <b-icon icon="arrow-repeat" /> Uppdatera
          </b-button>
        </b-col>
      </b-form-row>
      <b-form-row
        v-if="autoChangeEndDate"
        class="mb-2 redText"
      >
        <b-col
          sm="12"
          md="6"
          lg="4"
        >
          <span>Dina val översteg begränsningen i att konsumtionsperioden får vara max 28 dagar vid
            räckvidd & frekvens. Vi har därför nu automatiskt justerat slutdatumet till ett kortare
            intervall.</span>
        </b-col>
      </b-form-row>
    </b-form>

    <div
      v-if="loadingSite && reachSelected"
      class="text-center mb-2"
    >
      <hr>
      <b-spinner
        variant="primary"
        type="grow"
        label="Spinning"
      />
      <div>
        <small class="text-muted">Laddar räckvidd och frekvens...</small>
      </div>
    </div>
    <div v-else-if="reachSelected">
      <hr>
      <p class="mb-0">
        <small>
          Antal siter:
          <span class="font-weight-bold">
            {{ numberOfUniqueSitesInQueryKeys }}
          </span>
        </small>
      </p>
      <p class="mb-0">
        <small>
          Antal datum/svarsrader:
          <span class="font-weight-bold"> {{ numberOfRowsInResult }} </span>
        </small>
      </p>
      <p>
        <small>
          Paneldag: <span class="font-weight-bold"> {{ panelDaySite }} </span>
        </small>
      </p>
      <div class="d-flex">
        <b-form-radio-group
          v-model="measureTypeSelected"
          class="mr-auto"
          :options="measureTypeOptions"
          name="Relativ eller absolut"
          buttons
          button-variant="outline-primary"
        />
        <SiteReachExport
          :json="itemsSite"
          :header-items="headerItems"
        />
      </div>

      <b-table
        v-if="meassureType === 'absolute_reach'"
        id="reach-summary"
        class="mt-2"
        :bordered="true"
        :striped="true"
        :head-variant="'dark'"
        :items="itemsSite"
        :fields="fieldsAbsSite"
        :small="true"
        :responsive="true"
      />

      <b-table
        v-else-if="meassureType === 'relative_reach'"
        id="reach-summary"
        class="mt-2"
        :bordered="true"
        :striped="true"
        :head-variant="'dark'"
        :items="itemsSite"
        :fields="fieldsRelSite"
        :small="true"
        :responsive="true"
      />
    </div>
    <div
      v-else
      class="text-center mb-2"
    >
      <hr>
      <small
        class="text-danger"
      ><strong>Du måste välja målgrupp och måttet Reach under Målgrupper / Mått</strong></small>
    </div>
  </div>
</template>

<script>
import SiteReachExport from '../../Layout/Site/SiteReachExport';
import { daysBetween, addDays } from '../../../assets/js/utils.js';
import { mapGetters } from 'vuex';
import { dateToyymmddFormat } from '../../../assets/js/utils.js';

export default {
  name: 'SiteReach',
  components: {
    SiteReachExport,
  },
  data() {
    return {
      meassureType: 'absolute_reach',
    };
  },
  computed: {
    ...mapGetters([
      'itemsSite',
      'loadingSite',
      'fieldsAbsSite',
      'fieldsRelSite',
      'uniSizeSite',
      'resultCountSite',
      'panelDaySite',
    ]),
    minViewingTimeSelection: {
      get() {
        return this.$store.state.siteReachForm.min_viewing_time.selected;
      },
      set(value) {
        this.$store.commit('siteReachForm/updateMinViewingTimeSite', value);
        this.$store.commit('siteReachApiBody/updateMinViewingTimeSite', value);
      },
    },
    minViewingTimeOptions() {
      return this.$store.state.siteReachForm.min_viewing_time.options;
    },
    measureTypeSelected: {
      get() {
        return this.$store.state.siteReachForm.measure_type.selected;
      },
      set(value) {
        this.meassureType = value;
        this.$store.commit('siteReachForm/updateMeasureTypeSite', value);
        this.$store.commit('siteReachApiBody/updateMeasureTypeSite', value);
      },
    },
    measureTypeOptions() {
      return this.$store.state.siteReachForm.measure_type.options;
    },
    dateFrom: {
      get() {
        return this.$store.state.siteReachApiBody.payload.start_date;
      },
    },
    dateTo: {
      get() {
        return this.$store.state.siteReachApiBody.payload.end_date;
      },
    },
    measures() {
      return this.$store.state.siteReachApiBody.payload.measures;
    },
    numberOfSelectedRows() {
      return this.$store.state.siteReachApiBody.payload.queryKeys.length;
    },
    numberOfUniqueSitesInQueryKeys() {
      let queryKeys = this.$store.state.siteReachApiBody.payload.queryKeys.map(function(i) {
        return i.split(';');
      });
      let uniqueSites = [...new Set(queryKeys.map(item => item[0]))];
      return uniqueSites.length;
    },
    numberOfRowsInResult() {
      let dateItemsSite = this.itemsSite.filter(function(itemSite) {
        if (dateToyymmddFormat(itemSite.date_key) !== 'Invalid Date') return itemSite;
      });
      return dateItemsSite.length;
    },
    autoChangeEndDate() {
      return this.$store.state.siteReachApiBody.autoChangeEndDate;
    },
    headerItems() {
      return [
        {
          date_key: 'Period',
          measure_1: `${this.dateFrom}--${this.dateTo}`,
        },
        {
          date_key: 'Paneldag',
          measure_1: this.panelDaySite,
        },
        {
          date_key: 'Antal siter',
          measure_1: this.numberOfUniqueSitesInQueryKeys,
        },
        {
          date_key: 'Antal datum/svarsrader',
          measure_1: this.numberOfRowsInResult,
        },
      ];
    },
    reachSelected() {
      let reachSelected = false
      this.$store.state.siteApiBody.payload.measures
      const measuresSite = localStorage.getItem('measuresSite') || [];
      if(measuresSite.length > 0)
      {
        if(JSON.parse(measuresSite).filter(measure => measure.isReach).length > 0)
          reachSelected = true
      }
      return reachSelected
    },
  },
  watch: {
    '$store.state.siteReachResults.showToastErrorSite'() {
      if (this.$store.state.siteReachResults.showToastErrorSite) {
        this.$bvToast.toast('Okänt serverfel vid hämtning av sökresultat r&f site', {
          title: 'Fel',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
          bodyOutputType: 'trustedHtml',
        });
        this.$store.state.siteReachResults.showToastErrorSite = false;
      }
    },
  },
  methods: {
    siteSearchReach() {
      if (this.minViewingTimeSelection == -1) {
        this.$bvToast.toast('Du måste välja ett reachvillkor.', {
          title: 'Ej giltigt reachvillkor',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
          bodyOutputType: 'trustedHtml',
        });
        return;
      }
      let startDate = this.$store.state.siteReachApiBody.payload.start_date;
      let endDate = this.$store.state.siteReachApiBody.payload.end_date;
      let days = daysBetween(startDate, endDate);
      //Max days in reach is 28
      if (days >= this.config_MaxReachDays) {
        endDate = addDays(startDate, this.config_MaxReachDays - 1);
        this.$store.commit('siteReachApiBody/updateAutoChangeEndDate', true);
        this.$store.commit('siteReachApiBody/updateEndDate', endDate);
      } else {
        this.$store.commit('siteReachApiBody/updateAutoChangeEndDate', false);
      }

      this.$emit('onSiteSearchReach');
    },
    round(value, precision) {
      let multiplier = Math.pow(10, precision || 0);
      return (Math.round(value * multiplier) / multiplier).toString().replace('.', ',');
    },
  },
};
</script>
<style scoped>
.fontsizeconsumptionp {
  font-size: 0.875rem;
}
.redText {
  color: red;
  font-weight: bold;
  font-size: 0.8em;
}
</style>